import { useQuery } from "@tanstack/react-query";

import type { ListWorkflowTemplatesResponseJSON } from "@performyard/service-contracts";

import { ListWorkflowTemplatesParams, getWorkflowTemplates } from "../../services/defs/workflow-templates";
import type { PYUseQueryOptions } from "../StandardQueryArguments";

export const workflowTemplatesKeys = {
	all: ["WorkflowTemplates"] as const,
	list: (params?: ListWorkflowTemplatesParams) => [...workflowTemplatesKeys.all, "list", params] as const,
};

export const useWorkflowTemplates = (
	params: ListWorkflowTemplatesParams = {},
	options?: PYUseQueryOptions<ListWorkflowTemplatesResponseJSON>
) => {
	return useQuery({
		queryKey: workflowTemplatesKeys.list(params),
		queryFn: () => getWorkflowTemplates(params),
		meta: {
			errorMessage: "There was an error getting the workflow templates.",
		},
		...options,
	});
};
